module.exports = __webpack_public_path__ + "img/ic_siren.7753e93e.png";